<template>
  <div class="card shadow-sm h-100">
    <div class="p-4 pb-0 card-header">
      <div class="row">
        <div class="col-md-8 d-flex align-items-center">
          <h6 class="mb-0">{{ title }}</h6>
        </div>
      </div>
    </div>
    <div class="p-4 card-body">
      <div class="position-relative d-flex justify-content-center align-items-center pt-md-3">
        <!-- QR 이미지 (50%) -->
        <div class="w-50 text-center d-none d-md-block qr-box shadow img-fluid border-radius-xl move-on-hover">
          <img
            v-show="image"
            :src="image"
            alt="img-blur-shadow"
            style="max-width: 100%; height: auto;"
          />
        </div>

        <!-- 프로그레스바 (50%) -->
        <div class="w-100 w-md-50 p-3 p-md-2 ms-md-3">
          <h6 class="text-muted mb-0">조회 카운트</h6>
          <h4 class="font-weight-bolder display-6"><span class="clickable" @click="goQrReadMap();">{{ qrCurCnt }}</span>
            <small class="text-muted fs-6 ms-1" style="white-space: nowrap;">/&nbsp;&nbsp;{{ qrAvgCnt }} (AVG)</small>
          </h4>
          <div class="progress w-100">
            <div
              class="progress-bar bg-dark"
              :class="`w-${qrPer}`"
              role="progressbar"
              :aria-valuenow="qrPer"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProfileInfoCard",
  components: {
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    urn: {
      type: String,
      default: "",
    },
    qrAvgCnt: {
      type: Number,
      default: 0,
    },
    qrCurCnt: {
      type: Number,
      default: 50,
    },
    qrPer: {
      type: Number,
      default: 50,
    }
  },
  mounted() {

  },
  methods: {
    goQrReadMap(){
      this.$router.push({ name: 'QrReadMap', params: { urn: this.urn } });
    },
  }
};
</script>

<style scoped>
.qr-box {
  min-width: 220px;   /* 최소 가로 */
  min-height: 220px;  /* 최소 세로 */
  background-color: #f0f0f0;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.clickable { color: #2563eb;cursor: pointer; }
</style>